import React from "react";
import { Form } from "antd";
import { WrapLabel, LabelWrapper, InputWrapper, InputMargin } from "./styles";
import { ErrorMsgWrap } from "../../styles";
import CurrencyInput from "../../../../../../CommonComponents/CurrencyInput/CurrencyInput";

function InputComponent(props) {
  const { labelValue, placeholder, maxLength, onBlur, onChange, value, name, errorLabel=false, marginBottom='40px', focus, fullWidth=false, ariaLabel, id=false } = props;
  return (
    <Form hideRequiredMark>
      <WrapLabel>
        <InputMargin marginBottom={marginBottom}>
          <Form.Item
            colon={false}
            label={<LabelWrapper for={props.id}>{labelValue}</LabelWrapper>}
          >
            <InputWrapper>
              <CurrencyInput
                id={props.id}
                focus={focus}
                name={name}
                label={ariaLabel}
                placeholder={placeholder}
                maxLength={maxLength}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
                fullWidth={fullWidth}
              />
              {errorLabel &&
                <ErrorMsgWrap>
                  {errorLabel}
                </ErrorMsgWrap>}
            </InputWrapper>
          </Form.Item>
        </InputMargin>
      </WrapLabel>
    </Form>
  );
}

export default InputComponent;
